import React from 'react'
import { Tabs } from 'antd'
import { useUrlFilters } from 'src/libs/useUrlFilters'
import {
  FILTER_CONFIG_PM_TAB,
  PM_TAB_DEFAULT,
  PM_TAB_HISTORY,
  PM_TAB_LIST,
} from './const'
import { PaymentMethodsHistory } from './history'
import { ClientGatewayList } from './list'

const TAB_ITEMS = [
  {
    key: PM_TAB_LIST,
    label: 'Payment Methods',
    children: <ClientGatewayList />,
  },
  {
    key: PM_TAB_HISTORY,
    label: 'Payment Methods History',
    children: <PaymentMethodsHistory />,
  },
]

export const PaymentMethods: React.FC = () => {
  const { filters, setFilters } = useUrlFilters(FILTER_CONFIG_PM_TAB)

  const activeKey = TAB_ITEMS.some((tab) => tab.key === filters.pmTab)
    ? filters.pmTab
    : PM_TAB_DEFAULT

  return (
    <Tabs
      size="small"
      activeKey={activeKey}
      onChange={(key) => setFilters({ pmTab: key })}
      items={TAB_ITEMS}
    />
  )
}
